// react
import React, { useState } from "react";
import { Controller } from "react-hook-form";

// UI
import { message, Row, Col, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { Form } from "@ant-design/compatible";
import { ButtonLink } from "../../Common/Button/index";
import { RequiredFormLabel } from "../RequiredFormLabel/RequiredFormLabel";
import { RoundedCheckbox, Input, Select } from "../../Common/Input/index";
import PMSSelect from "../PMSSelect/PMSSelect";
// processing
import { PROPERTY_APPROVAL_OPPERATIONS } from "../../../utils/onboarding-helper";
import { TimezoneList } from "../../../utils/common-utils";
// css
import "./styles.css";

const Timezones = TimezoneList.map((time) => {
  return {
    value: time,
    label: time,
  };
});
const minHeightPX = `${window.innerHeight - 320}px`;

const PropertyApprover = (props) => {
  const {
    formSubmitRef,
    control,
    errors,
    onSubmit,
    customerId,
    allowedProperties,
    setValue,
    fields,
    remove,
    append,
    performPropertyOperation,
    watch,
    approveSinglePropertyClick,
  } = props;

  if (errors?.propertyData?.message) {
    message.error(errors?.propertyData?.message);
  }

  const [allProperySelectionChecked, setAllProperySelectionChecked] =
    useState(false);

  const checkField = async (checked) => {
    fields.forEach((element, index) => {
      setValue(`propertyData.${index}.property_selected`, checked);
    });
  };

  const addProperty = (
    propertyObject = {
      property_name: "",
      property_code: "",
      brand: "",
      pms: "",
      pos: "",
      property_time_zone: "",
      property_contact: {
        first_name: "",
        last_name: "",
        email: "",
        customer_id: customerId,
      },
      customer_id: customerId,
    },
  ) => {
    if (allowedProperties - fields.length < 1) {
      message.error(`Maximum allowed properties is ${allowedProperties}`);
    } else {
      append(propertyObject);
    }
  };

  const removeProperty = (property, index) => {
    if (property._id) {
      performPropertyOperation(
        PROPERTY_APPROVAL_OPPERATIONS.REMOVE,
        property._id,
        index,
      );
      remove(index);
    } else {
      remove(index);
    }
  };
  const deSelectOthers = async (selectedRowIndex) => {
    fields.forEach((_, index) => {
      if (index !== selectedRowIndex)
        setValue(`propertyData.${index}.property_selected`, false);
    });
    setAllProperySelectionChecked(false);
  };

  const propertyList = fields.map((property, index) => {
    return (
      <tr key={property.id}>
        <td>
          <Form.Item
            label={
              index === 0 ? (
                <RoundedCheckbox
                  checked={allProperySelectionChecked}
                  onChange={(e) => {
                    setAllProperySelectionChecked(e.target.checked);
                    checkField(e.target.checked);
                  }}
                />
              ) : (
                ""
              )
            }
          >
            <Controller
              control={control}
              name={`propertyData.${index}.property_selected`}
              render={({ field: { onChange, value } }) => (
                <RoundedCheckbox checked={value} onChange={onChange} />
              )}
            />
          </Form.Item>
        </td>
        <td>
          <Form.Item
            label={
              index === 0 ? <RequiredFormLabel value="Property Name" /> : ""
            }
            validateStatus={
              errors?.propertyData?.[index]?.property_name ? "error" : ""
            }
          >
            <Controller
              control={control}
              name={`propertyData.${index}.property_name`}
              render={({ field: { onChange, value } }) => (
                <Input
                  value={value}
                  onChange={onChange}
                  style={{ width: "300px" }}
                />
              )}
            />
          </Form.Item>
        </td>
        <td>
          <Form.Item
            label={index === 0 ? "Property Code" : ""}
            validateStatus={
              errors?.propertyData?.[index]?.property_code ? "error" : ""
            }
          >
            <Controller
              control={control}
              name={`propertyData.${index}.property_code`}
              render={({ field: { onChange, value } }) => (
                <Input value={value} onChange={onChange} />
              )}
            />
          </Form.Item>
        </td>
        <td>
          <Form.Item label={index === 0 ? "Brand" : ""}>
            <Controller
              control={control}
              name={`propertyData.${index}.brand`}
              render={({ field: { onChange, value } }) => (
                <Input value={value} onChange={onChange} />
              )}
            />
          </Form.Item>
        </td>
        <td>
          <Form.Item
            label={index === 0 ? <RequiredFormLabel value="PMS" /> : ""}
            validateStatus={errors?.propertyData?.[index]?.pms ? "error" : ""}
          >
            <Controller
              control={control}
              name={`propertyData.${index}.pms`}
              render={({ field: { onChange, value } }) => (
                <PMSSelect value={value} onChange={onChange} />
              )}
            />
          </Form.Item>
        </td>
        <td>
          <Form.Item label={index === 0 ? "POS" : ""}>
            <Controller
              control={control}
              name={`propertyData.${index}.pos`}
              render={({ field: { onChange, value } }) => (
                <Input value={value} onChange={onChange} />
              )}
            />
          </Form.Item>
        </td>
        <td>
          <Form.Item
            label={index === 0 ? <RequiredFormLabel value="Time Zone" /> : ""}
            validateStatus={
              errors?.propertyData?.[index]?.property_time_zone ? "error" : ""
            }
          >
            <Controller
              control={control}
              name={`propertyData.${index}.property_time_zone`}
              render={({ field: { onChange, value } }) => (
                <Select
                  value={value}
                  onChange={onChange}
                  placeholder="Time Zone"
                  options={Timezones}
                />
              )}
            />
          </Form.Item>
        </td>
        <td>
          <Form.Item
            label={index === 0 ? "Property Contact First Name" : ""}
            validateStatus={
              errors?.propertyData?.[index]?.property_contact?.first_name
                ? "error"
                : ""
            }
          >
            <Controller
              control={control}
              name={`propertyData.${index}.property_contact.first_name`}
              render={({ field: { onChange, value } }) => (
                <Input value={value} onChange={onChange} />
              )}
            />
          </Form.Item>
        </td>
        <td>
          <Form.Item
            label={index === 0 ? "Property Contact Last Name" : ""}
            validateStatus={
              errors?.propertyData?.[index]?.property_contact?.last_name
                ? "error"
                : ""
            }
          >
            <Controller
              control={control}
              name={`propertyData.${index}.property_contact.last_name`}
              render={({ field: { onChange, value } }) => (
                <Input value={value} onChange={onChange} />
              )}
            />
          </Form.Item>
        </td>
        <td>
          <Form.Item
            label={index === 0 ? "Property Contact Email" : ""}
            validateStatus={
              errors?.propertyData?.[index]?.property_contact?.email
                ? "error"
                : ""
            }
          >
            <Controller
              control={control}
              name={`propertyData.${index}.property_contact.email`}
              render={({ field: { onChange, value } }) => (
                <Input value={value} onChange={onChange} />
              )}
            />
          </Form.Item>
        </td>
        <td
          style={{ width: "450px", paddingTop: index === 0 ? "15px" : "0px" }}
        >
          <Row style={{ width: "350px" }}>
            <Col span={4}>
              <ButtonLink
                onClick={async () => {
                  deSelectOthers(index);
                  performPropertyOperation(
                    PROPERTY_APPROVAL_OPPERATIONS.APPROVE,
                    property,
                    index,
                  );
                }}
                disabled={!watch(`propertyData.${index}.property_selected`)}
              >
                <span style={{ textDecoration: "underline" }}>Approve</span>
              </ButtonLink>
            </Col>
            <Col span={9}>
              <ButtonLink
                onClick={() => {
                  deSelectOthers(index);
                  performPropertyOperation(
                    PROPERTY_APPROVAL_OPPERATIONS.VALIDATE,
                    property._id,
                    index,
                  );
                }}
                disabled={!watch(`propertyData.${index}.property_selected`)}
              >
                <span style={{ textDecoration: "underline" }}>
                  Request Validation
                </span>
              </ButtonLink>
            </Col>
            <Col span={4}>
              <ButtonLink
                onClick={() => {
                  removeProperty(property, index);
                }}
                disabled={!watch(`propertyData.${index}.property_selected`)}
              >
                <span style={{ textDecoration: "underline" }}>Remove</span>
              </ButtonLink>
            </Col>
          </Row>
        </td>
      </tr>
    );
  });

  return (
    <>
      <Row>
        <Col xxl={20} xl={20} lg={20} md={20} sm={24} xs={24}>
          <div style={{ display: "inline", paddingRight: "10px" }}>
            <span>Bulk Actions:</span>
            <ButtonLink
              style={{ padding: "5px" }}
              onClick={() => {
                performPropertyOperation(PROPERTY_APPROVAL_OPPERATIONS.APPROVE);
              }}
            >
              <span style={{ textDecoration: "underline" }}>Approve</span>
            </ButtonLink>
            <ButtonLink
              style={{ padding: "5px" }}
              onClick={() => {
                performPropertyOperation(
                  PROPERTY_APPROVAL_OPPERATIONS.VALIDATE,
                );
              }}
            >
              <span style={{ textDecoration: "underline" }}>
                Request Validation
              </span>
            </ButtonLink>
            <ButtonLink
              style={{ padding: "5px" }}
              onClick={() => {
                performPropertyOperation(PROPERTY_APPROVAL_OPPERATIONS.REMOVE);
              }}
            >
              <span style={{ textDecoration: "underline" }}>Remove</span>
            </ButtonLink>
          </div>
          <div style={{ display: "inline" }}>
            <div className="information-container">
              <span className="information-descriptor">
                Allowed Properties:
              </span>
              <span className="information-display"> {allowedProperties}</span>
            </div>
            <div className="information-container">
              <span className="information-descriptor">
                Uploaded Properties:
              </span>
              <span className="information-display"> {fields.length}</span>
            </div>
          </div>
        </Col>
        <Col xxl={4} xl={4} lg={4} md={4} sm={24} xs={24}>
          <ButtonLink
            onClick={() => {
              addProperty();
            }}
            size="large"
            icon={<PlusOutlined />}
          >
            Add Property
          </ButtonLink>
        </Col>
      </Row>
      <Row>
        <div
          className="onboarding-property-approve-form"
          style={{ minHeight: minHeightPX }}
        >
          <Form
            onSubmit={onSubmit}
            layout="vertical"
            className="onboarding-form"
          >
            {propertyList.length > 0 ? (
              <div className="property-container">
                <table>
                  <tbody>{propertyList}</tbody>
                </table>
              </div>
            ) : (
              <></>
            )}

            <Row>
              <Button
                type="primary"
                htmlType="submit"
                hidden
                ref={formSubmitRef}
              />
            </Row>
          </Form>
        </div>
      </Row>
    </>
  );
};

export default PropertyApprover;
